import SingleList from '../../services/SingleList';
import Cart from '../../services/Cart';

export default {
    namespaced: false,
    state: {
        singleWishlist: {},
        products: [],
        favorites: [],
        wishlist: {}
    },
    mutations: {
        REMOVE_FROM_PRODUCT(state, data) {
            const products = state.products;
            data.arr.forEach(item => {
                products.forEach((p, index) => {
                    if (item.ID === p.ID) {
                        products.splice(index, 1);
                    }
                });
            });
            state.products = products;
        },
        SET_SINGLE_WISHLIST_PRODUCT(state, data) {
            state.products = data || [];
        },
        SET_SINGLE_WISHLIST(state, data) {
            state.singleWishlist = data;
        },
        SET_WISHLIST(state, data) {
            state.wishlist = data;
        },
        SET_WISHLIST_TITLE(state, data) {
            state.wishlist.title = data;
        },
        CHANGE_ID_WISHLIST(state, data) {
            state.wishlist.ID = data;
        }
    },
    actions: {
        getSingleWishlist({ commit }, id) {
            const response = SingleList.getSingleWishlist(id);
            response.then(res => {
                commit('SET_SINGLE_WISHLIST', res.data);
                commit('SET_SINGLE_WISHLIST_PRODUCT', res.data.products);
                if (res.data.wishlist && res.data.wishlist[0]) {
                    commit('SET_WISHLIST', res.data.wishlist[0]);
                }
            });
        },
        removeManyFromWishlist({ commit }, obj) {
            const response = SingleList.removeManyFromWishlist(obj);
            response.then(() => {
                commit('REMOVE_FROM_PRODUCT', obj);
            });
        },
        moveItem({ commit }, obj) {
            const response = SingleList.moveItem(obj);
            response.then(() => {
                commit('REMOVE_FROM_PRODUCT', obj);
            });
        },
        editTitle({ commit }, obj) {
            const response = SingleList.editTitle(obj);
            response.then(res => {
                commit('SET_WISHLIST_TITLE', res.data);
            });
        },
        changeWishList({ commit }, data) {
            commit('CHANGE_ID_WISHLIST', data);
        },
        removeWishlistAndList(obj) {
            const response = SingleList.removeWishlistAndList(obj);
            response.then(res => {
                if (res.data === 'ok') {
                    window.location.href = kadraGlobal.Url + '/mylist';
                }
            });
        },
        addManyItemsToCart({ commit }, obj) {
            const response = Cart.addManyItems(obj);
            response.then(res => {
                if (res.data === 'ok') {
                    window.location.href = kadraGlobal.Url + '/cart/';
                }
            });
        }
    }
};
